import { useEffect, useState } from 'react'
import { useInterval } from '~shared/hooks/useInterval'
import alert from '../Assets/audio/new-order-sound.mp3'

const REPEAT_DELAY_MS = 10000

type Options = {
  active: boolean
}

export const useNotificationSound = ({ active }: Options) => {
  const [audio, setAudio] = useState<HTMLAudioElement | null>(null)
  const [dialogOpen, setDialogOpen] = useState<boolean>(true)

  const confirmAudioEnabled = () => {
    const _audio = new Audio(alert)
    _audio.load()
    _audio.addEventListener('canplaythrough', () => {
      setAudio(_audio)
    })
    setDialogOpen(false)
  }

  // Beep immediately on the rising edge of `active`, then repeat on an
  // interval until `active` becomes false.
  useEffect(() => {
    if (active) {
      audio?.play().catch(() => {})
    }
  }, [active, audio])

  useInterval(
    () => {
      audio?.play().catch(() => {})
    },
    active && audio ? REPEAT_DELAY_MS : null
  )

  return {
    dialogOpen,
    confirmAudioEnabled,
  }
}
